@if (!isReady) {
<div class="embedded-bootstrap">
  <div class="embedded-bootstrap__box">
    <div class="embedded-bootstrap__title">Loading AuthHub…</div>
    <div class="embedded-bootstrap__text">Using your Warehouse session.</div>

    @if (errorText) {
    <div class="embedded-bootstrap__error">{{ errorText }}</div>
    }
  </div>
</div>
} @else {
<router-outlet></router-outlet>
}
